import { MarginMode, OrderType } from "@cede/types";
import { create } from "zustand";

export type OrderSide = "long" | "short";

interface CexPerpsTradingFormState {
  // Order settings
  orderType: OrderType;
  leverage: number;
  marginMode: MarginMode;
  size: string;
  price: string;

  // Options
  reduceOnly: boolean;

  // Validation
  validationError: string | null;

  // Actions
  setOrderType: (type: OrderType) => void;
  setLeverage: (leverage: number) => void;
  setMarginMode: (mode: MarginMode) => void;
  setSize: (size: string) => void;
  setPrice: (price: string) => void;
  setReduceOnly: (reduceOnly: boolean) => void;
  setValidationError: (error: string | null) => void;
  reset: () => void;
}

const initialState = {
  orderType: OrderType.MARKET,
  leverage: 1,
  marginMode: "cross" as MarginMode,
  size: "",
  price: "",
  reduceOnly: false,
  validationError: null,
};

export const useCexPerpsTradingFormStore = create<CexPerpsTradingFormState>((set) => ({
  ...initialState,

  setOrderType: (orderType) => set({ orderType }),
  setLeverage: (leverage) => set({ leverage }),
  setMarginMode: (marginMode) => set({ marginMode }),
  setSize: (size) => set({ size, validationError: null }),
  setPrice: (price) => set({ price, validationError: null }),
  setReduceOnly: (reduceOnly) => set({ reduceOnly }),
  setValidationError: (validationError) => set({ validationError }),
  reset: () =>
    set((state) => ({
      ...initialState,
      // Preserve margin mode and leverage on reset
      marginMode: state.marginMode,
      leverage: state.leverage,
    })),
}));
